export default "__VITE_ASSET__421ded1e__"